import { cva } from 'class-variance-authority';

export const intervalInputTitleVariants = cva(
	'flex w-full items-center font-matter-sq text-lg leading-[150%] tracking-[-0.36px]',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const intervalInputIconVariants = cva('!size-5', {
	variants: {
		variant: {
			primary: 'text-gray-400',
			dark: 'text-white-dark-4/80'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const intervalInputClassesVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'bg-primary-light-4 border border-primary-light-3 text-white-dark-4/80 placeholder:text-white-dark-4/80 hover:border-white-dark-4 focus-within:border-white-dark-4'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const intervalInputSuffixVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const intervalInputLabelVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-white-dark-4!'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});
